import picklesIcon from './images/pickles.png';
import powdersIcon from './images/powders.png';
import masalasIcon from './images/masalas.png';

import picklesHeadingImg from './images/picklesh2.jpg';
import powdersHeadingImg from './images/masalash2.jpg';
import masalasHeadingImg from './images/spicesh2.jpg';
import aboutHeadingImg from './images/aboutush2.jpg';

import tomatoPickleImage from './images/tomato pickle.jpg';
import gonguraPickleImage from './images/gongura pickle.jpg';
import allamPickleImage from './images/allam pickle.jpg';
import chintakayaPickleImage from './images/chintakaya pickle.jpg';
import avakayaPickleImage from './images/avakaya pickle.jpg';
import nimmakayaPickleImage from './images/nimmakaya pickle.png';

import kandiPodiImage from './images/kandi podi.jpg';
import karivepakuPodiImage from './images/karivepaku podi.png';
import kobbariPodiImage from './images/kobbari podi.png';
import sambarPodiImage from './images/sambar podi.jpg';

import turmericPowderImage from './images/turmeric powder.png';
import redChilliPowderImage from './images/Chilli powder.png';
import dhaniyaPowderImage from './images/dhaniya powder.png';

export const quantityOptions = ['250 gms', '500 gms', '1 kg'];

/** Pickles / powders / masalas product grids use a wider content max-width */
export const wideStoreLayoutPageIds = ['pickles', 'powders', 'masalas'];

export const productsByPage = {
  pickles: [
    { id: 'tomato', name: 'Tomato Pickle', image: tomatoPickleImage },
    { id: 'gongura', name: 'Gongura Pickle', image: gonguraPickleImage },
    { id: 'allam', name: 'Allam Pickle', image: allamPickleImage },
    { id: 'chintakaya', name: 'Chintakaya Pickle', image: chintakayaPickleImage },
    { id: 'mamidi', name: 'Mamidi (Avakaya)', image: avakayaPickleImage },
    { id: 'nimmakaya', name: 'Nimmakaya Pickle', image: nimmakayaPickleImage },
  ],
  powders: [
    { id: 'kandi', name: 'Kandi Podi', image: kandiPodiImage },
    { id: 'karivepaku', name: 'Karivepaku Podi', image: karivepakuPodiImage },
    { id: 'kobbari', name: 'Kobbari Podi', image: kobbariPodiImage },
    { id: 'sambar', name: 'Sambar Podi', image: sambarPodiImage },
  ],
  masalas: [
    { id: 'turmeric', name: 'Turmeric Powder', image: turmericPowderImage },
    { id: 'red-chilli', name: 'Red Chilli Powder', image: redChilliPowderImage },
    { id: 'dhaniya', name: 'Dhaniya Powder', image: dhaniyaPowderImage },
  ],
};

export const navItems = [
  { id: 'home', label: 'HOME' },
  { id: 'pickles', label: 'PICKLES', headingImage: picklesHeadingImg },
  { id: 'powders', label: 'POWDERS', headingImage: powdersHeadingImg },
  { id: 'masalas', label: 'MASALAS', headingImage: masalasHeadingImg },
  { id: 'about', label: 'ABOUT US', headingImage: aboutHeadingImg },
];

export const categoryCards = [
  { id: 'pickles', title: 'Pickles', image: picklesIcon },
  { id: 'masalas', title: 'Masalas', image: masalasIcon },
  { id: 'powders', title: 'Powders', image: powdersIcon },
];

export const WHATSAPP_E164 = '917396624546';

export const allStoreProducts = [
  ...productsByPage.pickles,
  ...productsByPage.powders,
  ...productsByPage.masalas,
];

export function cartLineKey(productId, weight) {
  return `${productId}|${weight}`;
}

export function buildWhatsAppOrderText(cartLines) {
  const header = "Hello Pranavi's Kitchen, I'd like to place an order:\n\n";
  const lines = cartLines.map((line, i) => {
    const pieceWord = line.pieces === 1 ? 'piece' : 'pieces';
    return `${i + 1}. ${line.name}\n   Weight: ${line.weight}\n   Quantity: ${line.pieces} ${pieceWord}`;
  });
  const footer = '\n\nPlease confirm availability and total. Thank you!';
  return header + lines.join('\n\n') + footer;
}

export function getProductById(productId) {
  return allStoreProducts.find((p) => p.id === productId);
}